<script>
import NavBar from '@components/nav-bar'
import SideBar from '@components/side-bar'

export default {
  components: { NavBar, SideBar },
  data() {
    return {
      isMenuCondensed: false,
    }
  },
  methods: {
    toggleMenu() {
      this.isMenuCondensed = !this.isMenuCondensed
      document.body.classList.toggle('sidebar-enable')
      document.body.classList.toggle('enlarged')
    },
  },
}
</script>

<template>
  <div id="wrapper">
    <NavBar :user="user"/>
    <SideBar :user="user" :is-condensed="isMenuCondensed" />
    <!-- ============================================================== -->
    <!-- Start Page Content here -->
    <!-- ============================================================== -->

    <div class="content-page">
      <div class="content">
        <!-- Start Content-->
        <div class=""> <slot /> </div
      ></div>
    </div>
    <!-- <RightBar /> -->
  </div>
</template>
